package com.essntl.features.dashboard.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import core.dateformat.utils.parseLocalDateOrNull
import com.essntl.core.utils.viewmodel.PaginationState
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.itinerary.domain.model.*
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.features.task.domain.model.TaskModel
import kotlinx.datetime.*

data class DashboardState(
    val getAllProposal: State<List<ProposalModel>> = State(),

    val getAllItinerary: State<List<ItineraryToConfirmModel>> = State(),
    val filterOptions: ItineraryFilterOptions = ItineraryFilterOptions(),

    val getAllProfile: State<List<ProfileModel>> = State(),
    val getAllRequest: State<List<RequestModel>> = State(),
    val getAllTask: PaginationState<TaskModel> = PaginationState(),
    val getAllCategory: State<List<CategoryModel>> = State(),
    val updateLoading: List<String> = emptyList(),
    val getCurrentUserId: String? = null,
    val assigned: Boolean = true,
) {
    val itemsLoading: Boolean
        get() = getAllProposal.isLoading || getAllRequest.isLoading

    val itemsFailure: Boolean
        get() = getAllProposal.isFailure || getAllRequest.isFailure

    val itemsEmpty: Boolean
        get() = getAllProposal.data.orEmpty().isEmpty() && getAllRequest.data.orEmpty().isEmpty()

    val tasksLoading: Boolean
        get() = getAllCategory.isLoading

    val tasksFailure: Boolean
        get() = getAllTask.isFailure || getAllCategory.isFailure

    val itinerariesLoading: Boolean
        get() = getAllItinerary.isLoading

    val itinerariesFailure: Boolean
        get() = getAllItinerary.isFailure

    val filteredProposals
        get() = getAllProposal.data
            .orEmpty()
            .filter { proposal ->
                val proposalDate = parseLocalDateOrNull(proposal.createdAt) ?: return@filter false
                val currentDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
                val tenDaysAgo = currentDate.minus(10, DateTimeUnit.DAY)

                (proposal.status == ProposalModel.Status.InProgress ||
                    proposal.status == ProposalModel.Status.Todo) &&
                    proposalDate in tenDaysAgo..currentDate
            }
}

@Composable
fun DashboardState.rememberFilteredProposals() = remember(
    getAllProposal.data,
    getCurrentUserId,
) {
    filteredProposals
}
